
export const lmFilterLookupClickFunction = (
  event: any,
  filterLookup: SohoLookupStatic,
  clickArguments: FilterLookupFunctionClickArguments
) => {

  if (clickArguments === undefined) {
    return;
  }

  const listGridComponent = clickArguments.grid.settings.userObject();
  const column = clickArguments.column;

  if (!column.displayField || !column.displayField.compactFormatByForm) {
    return;
  }

  const listFilterLookupClickedEvent: LMListFilterLookupClickedEvent = {
    filterLookup,
    column
  };

  listGridComponent.listFilterLookupClicked.emit(listFilterLookupClickedEvent);
};
